import { addDays, addYears } from 'date-fns';
import { wrapEvent } from '../../utils/index.js';
import { KEYBOARD } from '../../constants/index.js';
import { YEARS_PER_ROW } from '../styled.js';

function getNavigationDistance(params) {
  var key = params.key,
    yearPickerVisible = params.yearPickerVisible;
  switch (key) {
    case KEYBOARD.ARROW_LEFT:
      return -1;
    case KEYBOARD.ARROW_RIGHT:
      return 1;
    case KEYBOARD.ARROW_UP:
      return yearPickerVisible ? -YEARS_PER_ROW : -7;
    case KEYBOARD.ARROW_DOWN:
      return yearPickerVisible ? YEARS_PER_ROW : 7;
    default:
      return undefined;
  }
}
function useKeyboardNavigation(props) {
  var onKeyDown = props.onKeyDown,
    focusedDate = props.focusedDate,
    setFocusedDate = props.setFocusedDate,
    focusedYear = props.focusedYear,
    setFocusedYear = props.setFocusedYear,
    yearPickerVisible = props.yearPickerVisible;
  var navigateDays = function navigateDays(days) {
    return setFocusedDate(addDays(focusedDate, days));
  };
  var navigateYears = function navigateYears(years) {
    return setFocusedYear(addYears(focusedYear, years));
  };
  var navigateFunction = yearPickerVisible ? navigateYears : navigateDays;
  var handleKeyDown = wrapEvent(onKeyDown, function (event) {
    var key = event.key;
    var preventScroll = function preventScroll() {
      return event.preventDefault();
    };
    var navigationDistance = getNavigationDistance({
      key: key,
      yearPickerVisible: yearPickerVisible
    });
    if (navigationDistance) {
      preventScroll();
      event.stopPropagation();
      navigateFunction(navigationDistance);
    }
  });
  return {
    handleKeyDown: handleKeyDown
  };
}

export { getNavigationDistance, useKeyboardNavigation };
